<div class="calendar-wrapper">

  <div class="calendar-container">
    @if (loadingEvents) {
    <div class="loading-events material-shadow">{{'general.loadingEvents'|translate}}</div>
    }

    <header class="calendar-header" (click)="today()">{{selectedDate | date:'E, dd MMMM yyyy'}}</header>
  
    <mat-calendar #calendar [(selected)]="selectedDate" [(dateClass)]="dateClass" (selectedChange)="dateChanged()">
    </mat-calendar>
  </div>

  @if (eventsDay.length>0) {
  <section class="events">
    <article class="event" *ngFor="let event of eventsDay" (click)="goToEvent(event)">
      <h4 class="title">{{event.title}}</h4>
      <p *ngIf="event.extra" class="extra">{{event.extra}}</p>
      <label class="category" [style.color]="event.color" [title]="event.titleCategory">{{event.titleCategory}}</label>
    </article>
  </section>
  }

</div>